<template>
  <div></div>
</template>

<script>
export default {
  name: "Prerendering",
  data() {
    return {
    };
  },
  computed: {
    isRankingRoute() {
      const routes = [
        'ranking-country-all',
        'ranking-country',
        'ranking-zone-all',
        'ranking-zone',
        'ranking-worldwide-all',
        'ranking-worldwide'
      ]
      return routes.indexOf(this.$route.name) !== -1;
    },
    isCourseRoute() {
      const routes = [
        'courses.about',
        'courses.directorInterview',
        'courses.reviews',
        'courses.vlog',
        'courses.videosPhotos',
        'courses.home'
      ]
      return routes.indexOf(this.$route.name) !== -1;
    },
    isImgLoaded() {
      return this.$store.state.toggle.isImgLoaded;
    },
    isRankingFetch() {
      return this.$store.state.toggle.isRankingFetch;
    },
    isCourseFetch() {
      return this.$store.state.toggle.isCourseFetch;
    },
    isTopMenuLoaded() {
      console.log('prerendering know top menu loaded')
      return this.$store.state.toggle.isTopMenuLoaded;
    },
    isCommonRoute() {
      return this.$store.getters.isCommonRoute;
    },
    isRendered() {
      console.log('isRendered touched')
      if(!this.isImgLoaded) {
        console.log('img not loaded')
        return false
      }
      if(this.isRankingRoute && !this.isRankingFetch) {
        console.log('ranking route url not fetched')
        return false
      }
      if(this.isCourseRoute && !this.isCourseFetch) {
        console.log('course not fetched')
        return false
      }
      if(this.isCommonRoute && !this.isTopMenuLoaded)  {
        console.log('top menu not fetched')
        return false
      }
      return true
    }
  },
  methods: {
  },
  watch: {
    isRendered: {
      handler(val) {
        console.log('isRendered changed', val)
        if(val) {
          if(this.isCommonRoute) {
            console.log('is common route. wait 2 sec')
            setTimeout(() => {
              console.log('do render')
              document.dispatchEvent(new Event("render-event"));
            }, 2000)
          } else {
            console.log('do render');
            document.dispatchEvent(new Event("render-event"));
          }
        }
      },
      immediate: true
    }
  }
};
</script>